<form (ngSubmit)="onSubmit()" [formGroup]="form">
  <div class="row g-3">
    <div class="col-lg-6">
      <input-validator formControlName="serialNumber" label="METER.SERIAL_NUMBER">
        <div class="input-group">
          <input
            formControlName="serialNumber"
            class="form-control"
            [readonly]="searchLoading()"
          >
          <button
            class="btn btn-primary"
            type="button"
            (click)="onSearch()"
            [disabled]="searchLoading()"
          >
            @if(searchLoading()) {
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            } @else {
              <i class="bi bi-search"></i>
            }
          </button>
        </div>
      </input-validator>
    </div>
    <div class="col-lg-6">
      <input
        formControlName="name"
        class="form-control"
        inputValidator
        label="METER.NAME"
        placeholder="z.B. Hauptzähler Strom"
      >
    </div>
    <div class="col-lg-6">
      <autocomplete
        formControlName="unitTypeId"
        [clearable]="false"
        [url]="unitTypeService.getActiveAll.bind(unitTypeService)"
        bindValue="id"
        inputValidator
        (onSelect)="setUnit($event)"
        label="METER.TYPE"
      >
        <ng-template #label let-item="item" ng-label-tmp>
          <span [onlyText]="true" [type]="item" unitType></span>
        </ng-template>
      </autocomplete>
    </div>
    <div class="col-lg-6">
      <input
        formControlName="unit"
        class="form-control"
        inputValidator
        label="BUILD_DASHBOARD.UNIT"
        readonly
      >
    </div>
    <div class="col-lg-6">
      <input
        formControlName="installationReading"
        class="form-control"
        inputValidator
        label="METER.INSTALLATION_READING"
        mask="9*"
      >
    </div>
    <div class="col-lg-6">
      <ng-select
        formControlName="category"
        [clearable]="false"
        [items]="categoryType"
        inputValidator
        label="METER.CATEGORY"
        bindValue="id"
        [readonly]="!!category"
      />
    </div>
    @if(!category) {
      <div class="col-12">
        <autocomplete
          formControlName="buildingId"
          [clearable]="false"
          [url]="propertiesService.getAll.bind(propertiesService)"
          inputValidator
          label="METER.BUILDING_ID"
        />
      </div>

      @if(form.get('category').value === CategoryType.APARTMENT) {
        <div class="col-12">
          <autocomplete
            formControlName="apartmentId"
            [clearable]="false"
            [url]="apartmentsService.getAll.bind(apartmentsService)"
            [parentControl]="form.get('buildingId')"
            inputValidator
            label="RESIDENTS.APT"
            bindLabel="apartmentName"
          />
        </div>
      }
    } @else {
      <div class="col-lg-6">
        <kep-input-label label="METER.BUILDING_ID" [required]="true" [disabled]="true"/>
        <input type="text" readonly [value]="building?.name" class="form-control">
      </div>
      @if(category === CategoryType.APARTMENT) {
        <div class="col-lg-6">
          <kep-input-label label="RESIDENTS.APT" [required]="true" [disabled]="true"/>
          <input type="text" readonly [value]="apartment?.apartmentName" class="form-control">
        </div>
      }
    }
    <div class="col-lg-6">
      <input
        formControlName="installationLocation"
        class="form-control"
        inputValidator
        label="METER.INSTALLATIONLOCATION"
        placeholder="z.B. Keller, Flur, Technikraum"
      >
    </div>
    <div class="col-lg-6">
      <datepicker
        formControlName="installationDate"
        inputValidator
        label="METER.INSTALLATIONDATE"
      />
    </div>
    <div class="col-lg-6">
      <input
        formControlName="quantity"
        class="form-control"
        inputValidator
        mask="9*"
        label="METER.QUANTITY"
      >
    </div>
    <div class="col-lg-6">
      <input
        formControlName="manufacturer"
        class="form-control"
        inputValidator
        label="METER.MANUFACTURER"
      >
    </div>
    <div class="col-lg-6">
      <input
        formControlName="model"
        class="form-control"
        inputValidator
        label="METER.MODEL"
      >
    </div>
    <div class="col-lg-6">
      <input
        class="form-control"
        formControlName="readingUrl"
        inputValidator
        label="METER.READING_URL">
    </div>
    <div class="col-12">
      <textarea
        inputValidator
        label="TRANSACTION.DESCRIPTION"
        [autoResize]="true"
        class="form-control"
        formControlName="description"
        pInputTextarea
        rows="5"
      ></textarea>
    </div>
  </div>

  <div class="text-end d-flex gap-2 justify-content-end mt-4">
    <p-button [disabled]="form.invalid || isPending()" styleClass="btn btn-primary d-flex" [loading]="isPending()" type="submit" [label]="'SAVE'|translate"></p-button>
    <button (click)="cancel()" class="btn btn-soft-primary" type="button">{{ 'CANCEL' | translate }}</button>
  </div>
</form>




